import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UIIcon } from '../../../icon/icon.enum';

@Component({
  selector: 'button[ui-bottom-navigation-item]',
  templateUrl: './bottom-navigation-item.component.html',
  styleUrls: ['./bottom-navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIBottomNavigationItemComponent {
  readonly icon = input.required<`${UIIcon}`>();
  readonly iconActive = input<`${UIIcon}`>();
}
